/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelNmfcClassOverride.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/nmfc-class-override";

export class AutogenModelNmfcClassOverride<RowType extends ModelRow> extends Endpoint<RowType, RowNmfcClassOverrideFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowNmfcClassOverride extends ModelRow<RowNmfcClassOverrideFields> {
	constructor(values?: Partial<RowNmfcClassOverrideFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowNmfcClassOverrideFields {
	add_timestamp: Date;
	add_userid: string;
	company_id: string;
	effective_timestamp: Date;
	expire_timestamp: Date;
	fak_profile_id: string;
	from_nmfc_class_code: string;
	mod_timestamp: Date;
	mod_userid: string;
	nco_status_code: string;
	nco_type_code: string;
	nco_uid: number;
	plc_uid: number;
	to_nmfc_class_code: string;
}

